import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/ServicePage.css";
import "../Styles/Service.css";
import IntlMessages from "../../../intl/IntlMessages";

const ServicePage = ({
  title,
  description,
  imageUrl,
  altText,
  heroBackgroundImage,
}) => {
  const navigate = useNavigate();
  const [activeProcess, setActiveProcess] = useState(0);

  const process = [
    {
      title: <IntlMessages id="process.discovery" />,
      description: <IntlMessages id="process.discuss" />,
      steps: [
        <IntlMessages id="process.analyse" />,
        <IntlMessages id="process.doing" />,
        <IntlMessages id="process.discuss" />,
      ],
    },
    {
      title: <IntlMessages id="process.proposition" />,
      description: <IntlMessages id="process.elaboration" />,
      steps: [
        <IntlMessages id="process.devis" />,
        <IntlMessages id="process.planning" />,
        <IntlMessages id="process.specification" />,
      ],
    },
    {
      title: <IntlMessages id="process.creation" />,
      description: <IntlMessages id="process.design" />,
      steps: [<IntlMessages id="process.uiux" />, <IntlMessages id="process.dev" />, <IntlMessages id="process.qualityTest" />],
    },
    {
      title: <IntlMessages id="process.delivery" />,
      description: <IntlMessages id="process.production" />,
      steps: [<IntlMessages id="process.deployment" />, <IntlMessages id="process.formation" />, <IntlMessages id="process.support" />],
    },
  ];

  const handleInterested = () => {
    navigate("/contact", { state: { fromServices: true } });
  };

  return (
    <div className="services-page">
      {/* Hero Section */}
      <div
        className="services-hero2"
        style={{ backgroundImage: `url(${heroBackgroundImage})` }}
      >
        <div className="services-hero">
          <h1>{title}</h1>
          <p>
            <IntlMessages id="content.digitalSolutions" />
          </p>
        </div>
      </div>

      {/* Main Section avec description et imge */}
      <div className="service-page-main">
        <div className="service-page-content">
          <div className="service-page-descriptiona">
            <h2 className="description-title">
              <IntlMessages id="navigation.description" />
            </h2>
            <p>{description}</p>
          </div>

          <div className="service-page-image">
            <img src={imageUrl} alt={altText} />
          </div>
        </div>
      </div>

      {/* Process Section */}
      <section className="process-section">
        <h2>
          <IntlMessages id="process.ourProcess" />
        </h2>
        <div className="process-timeline">
          {process.map((step, index) => (
            <div
              className={`process-step ${
                activeProcess === index ? "active" : ""
              }`}
              key={index}
              onMouseEnter={() => setActiveProcess(index)}
            >
              <div className="process-number">{index + 1}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
              <ul className="process-details">
                {step.steps.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="ctaa-section">
        <h2>
          <IntlMessages id="process.project" />
        </h2>
        <p>
          <IntlMessages id="process.title" />
        </p>
        <button className="ctaa-button" onClick={handleInterested}>
          <IntlMessages id="content.getInTouch" />
        </button>
      </section>
    </div>
  );
};

export default ServicePage;
